import { OnboardingWelcomeTestID, TextTestID } from "@/constants/TestID";
import type { FAIconName } from "@/ui/core";
import { Icon, Text } from "@/ui/core";
import { HStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface WelcomeTileProps {
  icon: FAIconName;
  title: string;
}
const WelcomeTile = ({ icon, title }: WelcomeTileProps) => {
  const baseTestID = OnboardingWelcomeTestID.Primary;

  return (
    <HStack
      alignItems="center"
      gap={12}
      justifyContent="center"
      marginVertical={6}
      testID={joinTestIDs(baseTestID, "welcome-tile")}
    >
      <Icon
        color={ColorToken.Primary100}
        name={icon}
        size="lg"
        testID={joinTestIDs(baseTestID, icon)}
      />
      <Text
        color={ColorToken.Primary90Variant}
        testID={joinTestIDs(baseTestID, TextTestID.Title)}
        variant="h5"
      >
        {title}
      </Text>
    </HStack>
  );
};

export type { WelcomeTileProps };

export default WelcomeTile;
